// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

// Images
import alertIcon from '../../../sass/images/icons/modal-leave.svg';

// Components
import PopUp from '.';

// My customs hooks
import useModalLeave from '../../hooks/useModalLeave';

function ModalLeave({ content, title, isBlocked, t }) {
  const { isModalOpen, closeModal, handleBlockedRoute, handleConfirmNavigationClick } =
    useModalLeave({ content, title, isBlocked });

  return (
    <>
      <Prompt when message={handleBlockedRoute} />
      {isModalOpen && (
        <PopUp
          open={isBlocked}
          close={closeModal}
          icon={alertIcon}
          title={title}
          description={content}
          go={t('leave-registration')}
          accept={handleConfirmNavigationClick}
          btnAccept
          modalDesign
          classNameBtn="close_modal_leave register"
          classNameContent="modal-reset"
        />
      )}
    </>
  );
}

ModalLeave.propTypes = {
  content: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isBlocked: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation('register')(ModalLeave);
